<template>
  <textarea ref="el"
    class="field__control"
    :value="modelValue ?? ''"
    :rows="rows"
    @input="onInput" />
</template>

<script>
export default {
  name: 'text-area',
  emits: ['update:modelValue'],
  props: {
    modelValue: { type: [String, Number], default: '' },
    rows: { type: [Number, String], default: 3 },
    // Grows with its text instead of scrolling.
    autogrow: { type: Boolean, default: false },
  },
  watch: {
    modelValue() {
      this.$nextTick(this.grow)
    },
  },
  mounted() {
    this.grow()
  },
  methods: {
    onInput(e) {
      this.$emit('update:modelValue', e.target.value)
      this.grow()
    },
    grow() {
      const el = this.$refs.el
      if (!this.autogrow || !el) return
      el.style.height = 'auto'
      el.style.height = el.scrollHeight + 'px'
    },
  },
}
</script>
